<template>
  <div
    class="chat-message-wrapper"
    :class="[
      props.item.alignment === 'right' ? 'items-end' : 'items-start',
      { 'opacity-50': props.item.processing },
    ]"
  >
    <div
      v-if="showTimestamp"
      class="chat-message-timestamp-wrap"
    >
      <span class="chat-message-timestamp-text">{{ props.item.timestamp }}</span>
    </div>
    <div
      class="chat-message-item"
      :class="props.item.alignment === 'right' ? 'bg-standard-bg' : 'bg-selected-bg'"
      @click="messageClick"
    >
      {{ props.item.content }}
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ChatItem } from '@/types/chat';
import { ref } from 'vue';

const showTimestamp = ref(false);

const messageClick = () => {
  if (props.item.processing) return;

  // Timestamp does not make sense for note transcript messages at current moment.
  // TOOD(senad): refactor note transcript messages
  // showTimestamp.value = !showTimestamp.value;
};

const props = defineProps<{
  item: ChatItem;
}>();
</script>

<style lang="scss">
.chat-message-wrapper {
  @apply flex w-full flex-col;

  .chat-message-timestamp-wrap {
    @apply flex justify-center flex-row;
    width: 80%;

    .chat-message-timestamp-text {
      @apply text-text-default text-xs;
    }
  }

  .chat-message-item {
    @apply p-2 border border-solid border-standard-border rounded-lg;
    @apply text-text-default text-sm box-border;
    width: 80%;
    word-wrap: break-word;
  }
}
</style>
